// extracted by mini-css-extract-plugin
export var screenLoader = "styles-module--screenLoader--2aa36";